import AIModelBadge from "../../../components/ai/AIModelBadge";
import SingleValueSelector from "../../../components/common/editors/SingleValueSelector";

export default function AIModelSelector({ value, onChange }) {

    const modelNames = [
        'claude-sonnet-5-5',
        'claude-opus-5-5',
        'gpt-6-astra',
        'gpt-6.1-sol',
        'gpt-6-luna',
        'gemini-flash-latest',
        'gemini-flash-lite-latest',
        'gemini-3.8-flash',
        'gemini-3.1-pro-preview',
    ];

    const models = modelNames.map(modelName => ({
        value: modelName,
        label: <span className="no-wrap">
            <AIModelBadge model={modelName} showName={true} />
            {modelName.match(/^gemini-2\.5-pro/) ? <span className="badge-pill badge-danger align-middle zoom-75">slow</span> : null}
        </span>
    }));

    return <SingleValueSelector placeholder='Default AI model' className={'flex-grow-1 zoom-75'} value={value} onChange={onChange} options={models} />
}
